import {Component, ViewEncapsulation} from '@angular/core';
import {ResponseDtoType} from '../../../dto/ResponseDtoType';
import {ImmediatelyRenderedMessageComponent} from '../immediately-rendered-message-component';

@Component({
    templateUrl: './thinking-indicator.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ThinkingIndicatorComponent extends ImmediatelyRenderedMessageComponent {

    public static TYPE: ResponseDtoType = 'thinkingindicator';
}
